// extracted by mini-css-extract-plugin
module.exports = {"section":"FAQLandownersPage_section__1ZbVR","sectionFullWidth":"FAQLandownersPage_sectionFullWidth__3gw8O","sectionMarginless":"FAQLandownersPage_sectionMarginless__2Cexs"};